//------------------------------------------------------------------------------
// マイスタンプ切抜き編集画面（EditMystamp[Pc|Sp].cshtml）との連携用SDK
//------------------------------------------------------------------------------

let editmystampSdkCallbackA: any;
let editmystampSdkCallbackB: any;
let editmystampSdkIFrame: any;

/**
 * 連携準備
 */
export function editmystampSdkInit(iframeId, cbOK, cbCancel): void {
    editmystampSdkIFrame = document.getElementById(iframeId);
    editmystampSdkCallbackA = cbOK;
    editmystampSdkCallbackB = cbCancel;
}

/**
 * 連携開始
 */
export function editmystampSdkCreate(url: string): void {
    editmystampSdkIFrame.setAttribute('src', url);
}

/**
 * コールバック
 */
function callback(e: any): void {
    if (e.data.action === 'EditMystampSaveMessage') {
        if (editmystampSdkCallbackA != undefined) {
            editmystampSdkCallbackA(e.data.message);
            editmystampSdkIFrame.setAttribute('src', '');
        }
    } else if (e.data.action === 'EditMystampCancelMessage') {
        if (editmystampSdkCallbackB != undefined) {
            editmystampSdkCallbackB(e.data.message);
            editmystampSdkIFrame.setAttribute('src', '');
        }
    }
}

window.removeEventListener('message', callback);
window.addEventListener('message', callback);
